/**
 * デバッグ用「全ステージ解放」バッジ(`services/debugUnlock.ts`)。
 *
 * フラグが有効なあいだだけ出る。クリックで即解除(確認ダイアログは出さない)。
 * 進捗データには触らないので、解除すれば元の解放状態に戻る。
 */

import { useSyncExternalStore } from 'react';
import {
  isDebugUnlockAll,
  setDebugUnlockAll,
  subscribeDebugUnlock,
} from '../../services/debugUnlock';
import './debug.css';

/** フラグの現在値を購読する。 */
export function useDebugUnlockAll(): boolean {
  return useSyncExternalStore(subscribeDebugUnlock, isDebugUnlockAll, () => false);
}

export function DebugUnlockBadge() {
  const enabled = useDebugUnlockAll();
  if (!enabled) return null;
  return (
    <button
      type="button"
      className="debug-unlock-badge"
      title="クリックすると デバッグ解放を やめます"
      onClick={() => setDebugUnlockAll(false)}
    >
      🔧 デバッグ: ぜんぶ かいほう
    </button>
  );
}
